

import BaseService from "../baseService";
import httpService from "../http/httpService";

class ResourceService extends BaseService {

	constructor() {
		super("com.jacada.common.ResourceService");
	}

	loadScripts(resourcesUrl, timeout) {
		return new Promise((resolve, reject)=> {
			if(!Array.isArray(resourcesUrl) || resourcesUrl.length == 0) {
				resolve();
			}

			let count = 0;
			let resourcesCount = resourcesUrl.length;

			for(let i = 0; i < resourcesCount; i++) {
				this.loadScript(resourcesUrl[i],function() {
					count++;
					if(count == resourcesCount) {
						resolve();
					}
				}, reject, timeout);
			}
		});
	};


	loadScript(url, callback, fail, timeout) {

		var script = document.createElement("script")
		script.type = "text/javascript";

		var ticks = 0;
		var failed = false;
		if(timeout) {
			var timer = setInterval(function() {
				ticks++;
				if(ticks*100 >= timeout) {
					clearInterval(timer);
					failed = true;
					fail();
				}
			}, 100);
		}

		if (script.readyState) { //IE
			if(!failed) {
				clearInterval(timer);
				script.onreadystatechange = function () {
					if (script.readyState == "loaded" || script.readyState == "complete") {
						script.onreadystatechange = null;
						callback();
					}
				};
			}
		} else { //Others
			script.onload = function () {
				if(!failed) {
					clearInterval(timer);
					callback();
				}
			};
		}

		script.src = url;
		document.getElementsByTagName("head")[0].appendChild(script);
	}

	loadThemeByUrl(themeUrl) {
		return new Promise((resolve, reject) =>{

			let headers = {};
			headers["Content-Type"] = "text/css";
			headers.Accept = "text/css";

			//load the theme
			httpService.execute({
				method: 'GET',
				url:themeUrl,
				headers  : headers,
			}).then((res)=> {
				//add the theme to end of the head section
				let style = document.createElement('style');
				style.type = 'text/css';
				style.setAttribute('role', 'theme');
				style.appendChild(document.createTextNode(res._xhr.responseText));

				let head = document.querySelector('head');
				head.appendChild(style);
				resolve();

			}).catch(()=>{
				reject();
			});
		});
	}
}

export default new ResourceService();


// WEBPACK FOOTER //
// ../common/services/src/utils/resourceService.js